<template>
  <DeleteConfirm
      itemKey="User"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Users from '@/services/users'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Users
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť užívateľa "' + Item.name + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť užívateľa "' + Item.name + '"?'
      },
      deleteData() {
        return Users
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
